import { render, staticRenderFns } from "./DealerList.vue?vue&type=template&id=219ed2c2&scoped=true"
import script from "./DealerList.vue?vue&type=script&lang=js"
export * from "./DealerList.vue?vue&type=script&lang=js"
import style0 from "./DealerList.vue?vue&type=style&index=0&id=219ed2c2&prod&lang=scss"
import style1 from "./DealerList.vue?vue&type=style&index=1&id=219ed2c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "219ed2c2",
  null
  
)

export default component.exports